import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./Pages.css";

const Solutions = () => {
  const solutions = [
    {
      category: "Data Intelligence and Insights",
      description: "Verified account, contact, and intent datasets mapped to your total addressable market.",
      benefits: ["Cleaner segmentation", "Higher outbound relevance", "Faster account prioritization"],
    },
    {
      category: "Demand Generation Programs",
      description: "Campaign architecture for outbound, inbound, and lifecycle stages with full funnel visibility.",
      benefits: ["More qualified responses", "Improved nurture conversion", "Consistent campaign cadence"],
    },
    {
      category: "Revenue Operations",
      description: "Funnel design, routing logic, scoring, and reporting frameworks that align teams.",
      benefits: ["Reduced lead leakage", "Clear ownership", "Stronger conversion diagnostics"],
    },
    {
      category: "Automation and AI Enablement",
      description: "Operational automations that reduce repetitive work and improve turnaround speed.",
      benefits: ["Lower manual load", "Quicker execution", "Process consistency"],
    },
  ];

  return (
    <main>
      <Helmet>
        <title>B2B Solutions | ThinkRise USA</title>
        <meta
          name="description"
          content="Explore ThinkRise USA solutions for B2B data intelligence, demand generation, revenue operations, and automation that improve conversion and pipeline velocity."
        />
      </Helmet>
      <section className="page-hero solutions-hero">
        <div className="container">
          <h1 className="page-hero-title">Solutions for Predictable Pipeline</h1>
          <p className="page-hero-subtitle">
            ThinkRise USA delivers integrated growth solutions tailored to your business stage and revenue goals.
          </p>
          <Link to="/contact" className="btn">Request a Solution Plan</Link>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section-title">Solution Categories</h2>
          <div className="solutions-grid-alt">
            {solutions.map((solution) => (
              <article key={solution.category} className="solution-category-card">
                <h3>{solution.category}</h3>
                <p>{solution.description}</p>
                <ul>
                  {solution.benefits.map((benefit) => (
                    <li key={benefit}>{benefit}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Solutions;
